module.exports = __webpack_public_path__ + "ed371f2db3e905688abfa14d14f25738.pdf";